import { ICreateStringArrayConfigs } from './createStringArrayConfigs.interface';

export const createStringArray = (length: number, configs?: ICreateStringArrayConfigs): string[] => {
  return Array.from(Array(length).keys(), index => {
    const currentIndex = configs && configs.withoutZero ? index + 1 : index;
    if (currentIndex < 10) return '0' + currentIndex;
    return String(currentIndex);
  });
};
